import React, {useMemo, useState} from 'react';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCColors from '@/Utils/CCColors';
import SlideModal from '@/Atoms/SlideModal';
import NewUserRegistration from '@/Components/NewUserRegistration';
import {ChipType} from '@/Atoms/ChipList/types';    

const AddNewPlayer = ({postSubmitCallback}) => {
    const {isMobileOrTab} = useMediaQuery();
    const [openNewUserModal, setOpenNewUserModal] = useState(false);
    const [name, setName] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [fideID, setFideID] = useState('');
    const [email, setEmail] = useState<string>('');
    const [gender, setGender] = useState<{value: number; key: string}>({
      key: '',
      value: 0,
    });
  
    const isValid = useMemo(() => {
      if (name?.length > 2 && dateOfBirth?.length === 10 && gender?.value > 0) {
        return true;
      } else if (fideID?.length > 3) {
        return true;
      }
      return false;
    }, [name, dateOfBirth, gender, fideID]);
  
    const handleGenderChange = (e: ChipType) => {
      setGender(e);
    };
    const handleNameChange = (text: string) => {
      setName(text);
    };
    const handleDOBChange = (text: string) => {
      setDateOfBirth(text);
    };
  
    const handleNewUserModal = () => {
      setOpenNewUserModal(prev => !prev);
    };
  
    return (
      <Box type="row-flex-end">
        <CCButton
          type="box"
          onPress={handleNewUserModal}
          titleStyle={{color: CCColors.White}}
          style={{width: !isMobileOrTab ? '100%' : '50%'}}>
          + Add new player
        </CCButton>
        <SlideModal
          type="side"
          modalHeaderTitle="New Registration"
          visible={openNewUserModal}
          onClose={handleNewUserModal}>
          <NewUserRegistration
            name={name}
            dateOfBirth={dateOfBirth}
            gender={gender}
            handleNameChange={handleNameChange}
            handleDOBChange={handleDOBChange}
            handleGenderChange={handleGenderChange}
            isValid={isValid}
            setFideID={setFideID}
            fideID={fideID}
            postSubmitCallBack={() => {
              handleNewUserModal();
              postSubmitCallback?.();
              // postSubmitCallBack();
            }}
            isMobileOrTab={isMobileOrTab}
          />
        </SlideModal>
      </Box>
    );
  };

export default AddNewPlayer;